// extracted by mini-css-extract-plugin
export default {"button":"menuButton_button__fA24b","secondary":"menuButton_secondary__hGL3Y","btn":"menuButton_btn__tMgzl","closeBtn":"menuButton_closeBtn__oPeOe"};